{
  "pt": {
    "installment_term": {
      "actions": {
        "addUnits": "Unidades",
        "add_fraction": "Adicionar fração",
        "create": "Criar",
        "create_and_share": "Criar e partilhar com o cliente",
        "create_price_term": "Nova regra",
        "delete": "Eliminar",
        "deleteMultiple": "Eliminar...",
        "delete_cancel": "Cancelar",
        "edit": "Editar",
        "newInstallment": "Fase de pagamento",
        "only_create": "Apenas criar",
        "publish_customer": "Publicar para o cliente",
        "selectAll": "Selecionar todas as prestações de {total} ",
        "selectOne": "Selecionar uma prestação",
        "take": "Tomar"
      },
      "attributes": {
        "description": "Descrição",
        "installments_count": "{count} prestação | {count} prestações",
        "name": "Título"
      },
      "labels": {
        "addAllSurcharges": "Adicionar todas as sobretaxas atuais",
        "addAllUnitsPrices": "Adicionar todos os preços unitários",
        "amount": "Montante da prestação",
        "balanceFractionTypes": "Tipos de frações de saldo",
        "balanceTotal": "Saldo Total",
        "containsSurcharges": "Contém sobretaxas",
        "create_decision_first": "Esta opção estará disponível quando tiver criado uma decisão.",
        "deleteInstallmentTerm": "Eliminar a fase de pagamento",
        "description": "Descrição",
        "documents": "Documentos",
        "duplicate_price_type": "Já existe uma fração com este tipo de preço.",
        "editInstallmentTerm": "Editar fase de pagamento",
        "edit_description": "Editar descrição",
        "fixed": "Fixo",
        "fixedAmount": "Montante fixo de",
        "for": "para",
        "forEachUnit": "de cada unidade",
        "fraction_types": {
          "absolute": "Montante fixo",
          "relative": "Percentagem"
        },
        "goToAmounts": "Selecionar montantes",
        "installments": "Finanças",
        "installmentsTitle": "Prestação",
        "installments_all_projects": "Finanças de todos os projetos",
        "invalidAmount": "Montante inválido",
        "list": "Lista",
        "name": "Fase de Pagamento #{count}",
        "noContainsSurcharges": "Não contém sobretaxas",
        "noInstallmentsToPay": "Nenhuma prestação pendente",
        "noUnitsClick": "Ainda não há unidades, clique aqui para adicionar",
        "ofThe": "do",
        "price_types": {
          "custom_amount": "Outros",
          "price_value": "Valor total",
          "price_value_construction": "Valor da construção",
          "price_value_construction_existing": "Custos da construção existente",
          "price_value_fees": "Honorários do arquiteto/engenheiro",
          "price_value_land": "Valor do terreno",
          "surcharge": "Sobretaxas",
          "unit": "Preços unitários"
        },
        "projectUnitsTotal": "{project_name} tem {units_count_max} unidades no total",
        "publish_now": "Publicar agora?",
        "rules": "Regras de pagamento",
        "rules_subtitle": "Defina a percentagem ou o montante a cobrar",
        "save_explainer": "Tornar esta fase de pagamento visível para os seus clientes? Ou guardar e publicar mais tarde?",
        "selectUnits": "Selecionar unidades",
        "selected": "{selected} prestação selecionada. | {selected} prestações selecionadas.",
        "shortcuts": "Atalhos",
        "show_installment_terms_for": "Mostrar prestações para",
        "step1Info": "Adicionar uma descrição",
        "step2Subtitle": "Selecione o seu projeto para incluir todas as suas unidades de uma só vez.",
        "step2Title": "Que unidades estão relacionadas com esta prestação?",
        "surcharges": "Sobretaxas",
        "total": "Total",
        "totalFixed": "Total fixo",
        "totalPaid": "Total pago",
        "totalRequested": "Total faturado",
        "totalSelected": "Todas as prestações de {total} são selecionadas.",
        "totalSurcharges": "Total de sobretaxas",
        "totalUnpaid": "Total não pago",
        "unitSelected": "Nenhuma unidade selecionada ainda | Uma unidade selecionada | {count} unidades selecionadas",
        "units": "Unidades"
      },
      "navigation": {
        "backToInstallmentTerms": "Voltar à visão geral das fases de pagamento"
      },
      "placeholders": {
        "amount": "Selecionar um montante fixo ou uma percentagem do valor unitário ou das sobretaxas",
        "description": "Por exemplo, 10% - Depois de betonar a laje no primeiro andar...",
        "due_date": "Fixar uma data até à qual a prestação deve ser paga",
        "employees": {
          "new": {
            "subtitle": "Adicione prestações e mantenha-se a par do seu estado",
            "title": "Criar uma síntese financeira"
          }
        },
        "installmentTermFractionNotice": "Os montantes das prestações já não podem ser ajustados porque algumas prestações já foram entregues ao comprador",
        "name": "Por exemplo, Fase de Pagamento #1, Fase de Pagamento - Sobretaxas",
        "summary": "Resumo",
        "surcharge": "sobretaxa"
      },
      "toasts": {
        "bulk_create": "Prestação criada com sucesso | Prestações criadas com sucesso",
        "bulk_delete": "Prestação eliminada com êxito | Prestações eliminadas com êxito",
        "bulk_update": "Prestação atualizada com êxito | Prestações atualizadas com êxito",
        "delete": "Prestação eliminada com sucesso",
        "update": "Prestação atualizada com sucesso"
      },
      "validation": {
        "fixedFractionLabel": "{price_type} já foi combinado com {fraction_type} noutra prestação existente. Apenas {fraction_type} é permitido para manter a coerência.",
        "needDescription": "Descrição necessária",
        "needInstallmentTermFraction": "É necessária uma regra de preço",
        "needNamePrimary": "O nome na língua principal ({language}) é obrigatório",
        "needUniquePricesTypes": "As regras não podem ter os mesmos tipos de preços dentro da mesma fase de pagamento",
        "needValidTerm": "O montante não pode ser 0 e o tipo de preço deve existir",
        "selectInstallmentTerm": "Selecionar pelo menos 1 prestação",
        "selectUnit": "Selecionar pelo menos 1 unidade"
      }
    }
  }
}
